module.exports = __webpack_public_path__ + "static/media/trumpetDefault.1fb98d0d.png";